module.exports = __webpack_public_path__ + "fonts/heebo-v9-latin-700.6bedc8db.woff2";